(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gn-bog-spotlight"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gn-bog-spotlight')) {
  customElements.define('gn-bog-spotlight', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      const setActive = (index) => {
        this.querySelectorAll('[data-index]').forEach((el) => el.classList.toggle('is-active', el.dataset.index === index));
      };
      this.querySelectorAll('.gn-bog__feature, .gn-bog__dot').forEach((el) => {
        el.addEventListener('mouseenter', () => setActive(el.dataset.index), { signal });
        el.addEventListener('focus', () => setActive(el.dataset.index), { signal });
      });
      this.querySelector('.gn-bog__features')?.addEventListener('mouseleave', () => setActive(null), { signal });
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) setActive(null); }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-faq-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gn-faq-hub')) {
  customElements.define('gn-faq-hub', class extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('[data-nav]');
      if (!this.nav || !('IntersectionObserver' in window)) return;
      this.links = [...this.nav.querySelectorAll('a[href^="#"]')];
      this.panels = this.links.map((link) => document.getElementById(link.hash.slice(1))).filter(Boolean);
      // Highlight the topic currently in view.
      this.observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (!visible.length) return;
        const top = visible.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0].target;
        this.setCurrent(top.id);
      }, { rootMargin: '-30% 0px -60% 0px' });
      this.panels.forEach((panel) => this.observer.observe(panel));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    /** @param {string} id */
    setCurrent(id) {
      for (const link of this.links) {
        const current = link.hash === `#${id}`;
        if (current) {
          link.setAttribute('aria-current', 'true');
          // Keep the active chip visible in the horizontally scrolling nav without moving the page.
          this.nav.scrollTo({ left: link.offsetLeft - (this.nav.clientWidth - link.offsetWidth) / 2, behavior: 'smooth' });
        } else {
          link.removeAttribute('aria-current');
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-founder-podcasts"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gn-founder-podcasts')) {
  customElements.define('gn-founder-podcasts', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.gn-podcasts__player');
      this.addEventListener('click', (event) => {
        const cardButton = event.target.closest('[data-open-card]');
        if (cardButton) {
          cardButton.closest('.gn-podcasts__card').querySelector('button[data-video-id], a.gn-podcasts__media')?.click();
          return;
        }
        const trigger = event.target.closest('[data-video-id]');
        if (trigger) {
          const id = trigger.dataset.videoId;
          const youtube = trigger.dataset.videoType === 'youtube';
          if (!(youtube ? /^[\w-]+$/ : /^\d+$/).test(id)) return;
          this.opener = trigger;
          const iframe = document.createElement('iframe');
          iframe.src = youtube ? `https://www.youtube-nocookie.com/embed/${id}?autoplay=1` : `https://player.vimeo.com/video/${id}?autoplay=1`;
          iframe.title = trigger.dataset.title || 'Founder conversation';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          this.querySelector('[data-dialog-title]').textContent = iframe.title;
          this.querySelector('.gn-podcasts__fallback a').href = youtube ? `https://www.youtube.com/watch?v=${id}` : `https://vimeo.com/${id}`;
          this.player.replaceChildren(iframe);
          this.dialog.showModal();
        }
        if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.player.replaceChildren();
        this.opener?.focus();
      });
    }
    disconnectedCallback() { this.player?.replaceChildren(); this.dialog?.close(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gn-ingredients')) {
    class GnIngredients extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.track = this.querySelector('.gn-ing__track');
        this.buttons = [...this.querySelectorAll('.gn-ing__nav')];
        if (!this.track) return;
        for (const button of this.buttons) {
          button.hidden = false;
          button.addEventListener('click', () => this.step(Number(button.dataset.dir)), { signal });
        }
        this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
        window.addEventListener('resize', () => this.update(), { passive: true, signal });
        this.update();
      }

      disconnectedCallback() {
        this.abort?.abort();
      }

      /** @param {number} dir 1 for next, -1 for previous */
      step(dir) {
        const card = this.track.querySelector('.gn-ing__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: dir * rtl * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const pos = Math.abs(this.track.scrollLeft);
        const [prev, next] = this.buttons;
        if (prev) prev.disabled = pos <= 2;
        if (next) next.disabled = pos >= max - 2;
        this.toggleAttribute('data-static', max <= 2);
      }
    }
    customElements.define('gn-ingredients', GnIngredients);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-launch-duo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gn-launch-duo')) {
  customElements.define('gn-launch-duo', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-duo-jump]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const id = decodeURIComponent(new URL(link.href).hash.slice(1));
          const target = id && document.getElementById(id);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
          history.replaceState(null, '', `#${id}`);
        }, { signal });
      });

      const rail = this.querySelector('.gn-duo-rail');
      if (!rail || !('IntersectionObserver' in window)) return;
      const links = [...rail.querySelectorAll('a[data-target]')];
      const targets = links.map((link) => document.getElementById(link.dataset.target)).filter(Boolean);
      if (!targets.length) return;
      rail.hidden = false;
      const visible = new Map();
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) visible.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
        const inView = [this.querySelector('.gn-duo'), ...targets].some((el) => (visible.get(el) || 0) > 0);
        rail.classList.toggle('is-visible', inView);
        let best = null;
        let bestRatio = 0;
        for (const el of targets) {
          const ratio = visible.get(el) || 0;
          if (ratio > bestRatio) { best = el; bestRatio = ratio; }
        }
        links.forEach((link) => {
          const active = best && link.dataset.target === best.id;
          link.classList.toggle('is-active', Boolean(active));
          if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        });
      }, { threshold: [0, 0.15, 0.3, 0.5, 0.7, 1] });
      [this.querySelector('.gn-duo'), ...targets].forEach((el) => el && this.observer.observe(el));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-launch-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gn-launch-story')) {
  customElements.define('gn-launch-story', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.acts = [...this.querySelectorAll('[data-act]')];
      this.layers = [...this.querySelectorAll('[data-layer]')];
      this.pills = [...this.querySelectorAll('[data-go]')];
      if (!this.acts.length) return;

      // Pick the story crossing the middle of the screen. A capturing scroll listener also catches
      // Horizon's desktop scroll container (.page-wrapper), not just window scrolling.
      this.update = () => {
        const middle = window.innerHeight / 2;
        let best = 0;
        let bestDistance = Infinity;
        this.acts.forEach((act, i) => {
          const rect = act.getBoundingClientRect();
          const distance = rect.top <= middle && rect.bottom >= middle ? 0 : Math.min(Math.abs(rect.top - middle), Math.abs(rect.bottom - middle));
          if (distance < bestDistance) { bestDistance = distance; best = i; }
        });
        this.activate(best);
      };
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.classList.add('is-ready');
      document.addEventListener('scroll', this.update, { capture: true, passive: true, signal });
      window.addEventListener('resize', this.update, { passive: true, signal });
      this.update();

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.pills.forEach((pill) => pill.addEventListener('click', () => {
        const act = this.acts[Number(pill.dataset.go)];
        act?.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
      }, { signal }));

      // Press-to-feel bristles: bristles near the press point bend away and compress, then spring back softly.
      this.querySelectorAll('[data-feel]').forEach((feel) => {
        const pad = feel.querySelector('.gn-feel__pad');
        const svg = feel.querySelector('svg');
        const bristles = [...feel.querySelectorAll('.gn-feel__b')];
        if (!pad || !svg || !bristles.length) return;
        const bend = (clientX, strength) => {
          const box = svg.getBoundingClientRect();
          const px = ((clientX - box.left) / box.width) * 200;
          bristles.forEach((b) => {
            const dx = Number(b.dataset.x) - px;
            const near = Math.exp(-(dx * dx) / (2 * 38 * 38));
            b.style.setProperty('--bend', `${Math.max(-1, Math.min(1, dx / 60)) * 34 * strength * (0.35 + near)}deg`);
            b.style.setProperty('--squish', `${1 - 0.28 * strength * near}`);
          });
        };
        const release = () => {
          feel.classList.remove('is-active', 'is-pressed');
          bristles.forEach((b) => { b.style.removeProperty('--bend'); b.style.removeProperty('--squish'); });
        };
        let pressed = false;
        pad.addEventListener('pointerdown', (e) => { pressed = true; pad.setPointerCapture?.(e.pointerId); feel.classList.add('is-active', 'is-pressed'); bend(e.clientX, 1); }, { signal });
        pad.addEventListener('pointermove', (e) => {
          if (pressed) { bend(e.clientX, 1); return; }
          if (e.pointerType === 'mouse') { feel.classList.add('is-active'); bend(e.clientX, 0.35); }
        }, { signal });
        ['pointerup', 'pointercancel'].forEach((t) => pad.addEventListener(t, () => { pressed = false; release(); }, { signal }));
        pad.addEventListener('pointerleave', () => { if (!pressed) release(); }, { signal });
        pad.addEventListener('keydown', (e) => {
          if (e.key !== ' ' && e.key !== 'Enter') return;
          e.preventDefault();
          const box = svg.getBoundingClientRect();
          feel.classList.add('is-active', 'is-pressed'); bend(box.left + box.width / 2, 1);
          setTimeout(release, 450);
        }, { signal });
      });

      // Brush anatomy: hovering or focusing a numbered benefit highlights its marker on the image.
      const setMarker = (act, marker) => {
        this.querySelectorAll(`[data-layer="${act}"] [data-dot], [data-act="${act}"] [data-dot]`).forEach((dot) => dot.classList.toggle('is-active', dot.dataset.dot === marker));
        this.querySelectorAll(`[data-act="${act}"] [data-marker]`).forEach((item) => item.classList.toggle('is-active', item.dataset.marker === marker));
      };
      this.querySelectorAll('[data-marker]').forEach((item) => {
        const act = item.closest('[data-act]').dataset.act;
        item.addEventListener('mouseenter', () => setMarker(act, item.dataset.marker), { signal });
        item.addEventListener('focus', () => setMarker(act, item.dataset.marker), { signal });
        item.addEventListener('mouseleave', () => setMarker(act, null), { signal });
        item.addEventListener('blur', () => setMarker(act, null), { signal });
      });
    }

    activate(index) {
      if (index === this.current) return;
      this.current = index;
      const act = this.acts[index];
      if (act?.dataset.bg) this.style.setProperty('--story-bg', act.dataset.bg);
      this.acts.forEach((el, i) => el.classList.toggle('is-active', i === index));
      this.layers.forEach((el, i) => el.classList.toggle('is-active', i === index));
      this.pills.forEach((el, i) => el.classList.toggle('is-active', i === index));
      const num = act?.querySelector('[data-count]');
      // Count-up disabled: content stays still while the page scrolls.
    }

    // Count the hero number up from zero, keeping any prefix/suffix and the original decimals.
    countUp(el) {
      el.dataset.counted = 'true';
      const raw = el.dataset.count;
      const match = raw.match(/^(\D*)([\d.,]+)(.*)$/);
      if (!match || this.reduceMotion?.matches) return;
      const [, pre, numText, post] = match;
      const target = parseFloat(numText.replace(/,/g, ''));
      const decimals = (numText.split('.')[1] || '').length;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / 1100);
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = `${pre}${(target * eased).toFixed(decimals)}${post}`;
        if (t < 1) requestAnimationFrame(step); else el.textContent = raw;
      };
      requestAnimationFrame(step);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-oral-care-routine"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gn-routine-guide'))customElements.define('gn-routine-guide',class extends HTMLElement{
connectedCallback(){
 if(this.controller)this.controller.abort();this.controller=new AbortController();const options={signal:this.controller.signal};
 this.tabs=[...this.querySelectorAll('[data-step]')];this.panels=[...this.querySelectorAll('[data-panel]')];if(!this.tabs.length)return;
 this.querySelector('.gn-guide').classList.add('is-ready');
 this.addEventListener('click',e=>{const tab=e.target.closest('[data-step]');if(tab){this.select(this.tabs.indexOf(tab));return;}if(e.target.closest('[data-prev]'))this.select(this.index-1);if(e.target.closest('[data-next]'))this.select(this.index+1)},options);
 this.addEventListener('keydown',e=>{const tab=e.target.closest('[data-step]');if(!tab)return;let n=this.tabs.indexOf(tab);if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(n+1)%this.tabs.length;else if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(n-1+this.tabs.length)%this.tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.tabs.length-1;else return;e.preventDefault();this.select(n);this.tabs[n].focus()},options);
 this.addEventListener('shopify:block:select',e=>{const tab=e.target.closest('[data-step]');if(tab)this.select(this.tabs.indexOf(tab))},options);
 this.select(0);
}
disconnectedCallback(){this.controller?.abort()}
select(n){if(n<0||n>=this.tabs.length)return;this.index=n;const current=this.tabs[n];const duration=current.dataset.time?.trim();this.querySelector('[data-clock-time]').textContent=duration||'As directed';this.querySelector('[data-clock-time]').dataset.pending=String(!duration);this.querySelector('[data-clock-step]').textContent='STEP '+String(n+1).padStart(2,'0');this.querySelector('[data-clock-name]').textContent=current.dataset.name;const wheel=this.querySelector('.gn-guide__wheel');const arc=360/this.tabs.length;wheel.style.setProperty('--angle',(n*arc)+'deg');wheel.style.setProperty('--start',(n*arc)+'deg');wheel.style.setProperty('--end',((n+1)*arc)+'deg');this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===n));tab.tabIndex=i===n?0:-1;this.panels[i].hidden=i!==n});this.querySelector('[data-count]').textContent=String(n+1).padStart(2,'0')+' / '+String(this.tabs.length).padStart(2,'0');this.querySelector('[data-prev]').disabled=n===0;this.querySelector('[data-next]').disabled=n===this.tabs.length-1;this.querySelector('[data-next]').textContent=n<this.tabs.length-1?'Next: '+this.tabs[n+1].dataset.name:'Routine complete ✓'}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-pdp-ebc"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gn-ebc-carousel')){
customElements.define('gn-ebc-carousel',class extends HTMLElement{
  connectedCallback(){
    if(this.bound)return;this.bound=true;
    this.track=this.querySelector('.gn-ebc__track');
    this.addEventListener('click',e=>{
      if(!this.track)return;
      const w=this.track.clientWidth;
      if(e.target.closest('[data-prev]'))this.track.scrollBy({left:-w,behavior:'smooth'});
      if(e.target.closest('[data-next]'))this.track.scrollBy({left:w,behavior:'smooth'});
    });
  }
});
}
if(!customElements.get('gn-ebc-variant-root')){
customElements.define('gn-ebc-variant-root',class extends HTMLElement{
  connectedCallback(){
    if(this.bound)return;this.bound=true;
    this.current=this.dataset.variantId;
    this.cache=new Map();
    this.ids=new Set((this.dataset.variantIds||'').split(',').filter(Boolean));
    this.onForm=e=>{const t=e.target;if(t&&t.matches&&t.matches('form[action*="/cart/add"] [name="id"]')&&t.value)this.swap(String(t.value));};
    document.addEventListener('change',this.onForm);
    try{if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){this.unsub=subscribe(PUB_SUB_EVENTS.variantChange,ev=>{const v=ev&&ev.data&&ev.data.variant;if(v)this.swap(String(v.id));});}}catch(e){}
  }
  disconnectedCallback(){document.removeEventListener('change',this.onForm);if(this.unsub)this.unsub();}
  swap(id){
    if(!id||id===this.current)return;
    if(!this.ids.has(id))return;
    this.current=id;
    this.fetchMarkup(id).then(m=>{if(m==null||id!==this.current)return;this.innerHTML=m;}).catch(e=>console.error(e));
  }
  fetchMarkup(id){
    if(this.cache.has(id))return Promise.resolve(this.cache.get(id));
    const url=this.dataset.url+'?variant='+encodeURIComponent(id)+'&section_id='+encodeURIComponent(this.dataset.sectionId);
    return fetch(url).then(r=>r.text()).then(t=>{const d=new DOMParser().parseFromString(t,'text/html');const s=d.querySelector('gn-ebc-variant-root');const m=s?s.innerHTML:null;this.cache.set(id,m);return m;});
  }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-pdp-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gn-pdp-hero')){
customElements.define('gn-pdp-hero',class extends HTMLElement{
  connectedCallback(){
    if(this.bound)return;this.bound=true;
    this.main=this.querySelector('.gn-pdp__main-img');
    this.addEventListener('click',e=>{
      const t=e.target.closest('.gn-pdp__thumb');
      if(!t||!this.main)return;
      this.main.src=t.dataset.src;
      this.querySelectorAll('.gn-pdp__thumb').forEach(b=>b.classList.toggle('is-active',b===t));
    });
  }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gn-pdp-tabs')){
customElements.define('gn-pdp-tabs',class extends HTMLElement{
  connectedCallback(){
    if(this.bound)return;this.bound=true;
    this.tabs=[...this.querySelectorAll('.gn-tabs__tab')];
    this.panels=[...this.querySelectorAll('.gn-tabs__panel')];
    this.addEventListener('click',e=>{const t=e.target.closest('.gn-tabs__tab');if(t)this.activate(this.tabs.indexOf(t));});
    this.addEventListener('keydown',e=>{
      if(!e.target.classList||!e.target.classList.contains('gn-tabs__tab'))return;
      const i=this.tabs.indexOf(e.target);let n=null;
      if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;
      if(e.key==='ArrowLeft')n=(i-1+this.tabs.length)%this.tabs.length;
      if(n!==null){e.preventDefault();this.activate(n);this.tabs[n].focus();}
    });
  }
  activate(i){
    if(i<0)return;
    this.tabs.forEach((t,idx)=>{const on=idx===i;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on?'true':'false');t.tabIndex=on?0:-1;});
    this.panels.forEach((p,idx)=>{const on=idx===i;p.classList.toggle('is-active',on);p.hidden=!on;});
  }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-podcast-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gn-podcast-hub')) {
  customElements.define('gn-podcast-hub', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('[data-player]');
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-video-id]');
        if (trigger) {
          const id = trigger.dataset.videoId;
          const youtube = trigger.dataset.videoType === 'youtube';
          if (!(youtube ? /^[\w-]+$/ : /^\d+$/).test(id)) return;
          this.opener = trigger;
          const iframe = document.createElement('iframe');
          iframe.src = youtube ? `https://www.youtube-nocookie.com/embed/${id}?autoplay=1` : `https://player.vimeo.com/video/${id}?autoplay=1`;
          iframe.title = trigger.dataset.title || '';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          this.querySelector('[data-dialog-title]').textContent = iframe.title;
          this.player.replaceChildren(iframe);
          this.dialog.showModal();
          return;
        }
        if (event.target.closest('[data-close]') || event.target === this.dialog) this.closeVideo();
      }, { signal });
      // Escape closes the dialog natively; the close event stops playback there.
      this.dialog.addEventListener('close', () => this.cleanup(), { signal });
    }

    closeVideo() {
      if (this.dialog.open) this.dialog.close();
      this.cleanup();
    }

    cleanup() {
      if (!this.player.hasChildNodes()) return;
      this.player.replaceChildren();
      this.opener?.focus();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.player?.replaceChildren();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-ritual-player"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gn-ritual-player')) {
customElements.define('gn-ritual-player', class extends HTMLElement {
  connectedCallback() {
    if (this.bound) return; this.bound = true;
    this.items = [...this.querySelectorAll('.gn-player__item')];
    this.steps = this.items.map(el => ({
      sec: Math.max(1, parseInt(el.dataset.seconds, 10) || 60),
      name: el.dataset.name || '',
      howto: el.dataset.howto || '',
      ico: el.querySelector('.gn-player__item-ico').innerHTML
    }));
    this.total = this.steps.reduce((a, s) => a + s.sec, 0);
    this.prog = this.querySelector('.gn-player__prog');
    this.timeEl = this.querySelector('.gn-player__time');
    this.nameEl = this.querySelector('.gn-player__name');
    this.icoEl = this.querySelector('.gn-player__ico');
    this.statusEl = this.querySelector('.gn-player__status');
    this.playBtn = this.querySelector('.gn-player__btn--play');
    this.started = false; this.playing = false; this.done = false;
    this.current = 0; this.remaining = this.steps[0] ? this.steps[0].sec : 0;

    this.addEventListener('click', e => {
      const a = e.target.closest('[data-action]');
      if (a) { if (a.dataset.action === 'toggle') this.toggle(); if (a.dataset.action === 'skip') this.skip(); if (a.dataset.action === 'reset') this.reset(); }
      const j = e.target.closest('[data-jump]');
      if (j) this.jump(+j.dataset.jump);
    });
    this.loop = this.loop.bind(this);
    this.renderIdle();
  }
  fmt(s){ s = Math.ceil(s); const m = Math.floor(s/60); return m + ':' + String(s%60).padStart(2,'0'); }
  renderIdle(){
    this.timeEl.textContent = this.fmt(this.total);
    this.nameEl.textContent = 'Full ritual';
    this.icoEl.innerHTML = '';
    this.prog.style.strokeDashoffset = 0;
    this.playBtn.textContent = 'Start your ritual';
    this.statusEl.textContent = "Press start and we'll guide you through all six minutes.";
    this.items.forEach(el => el.classList.remove('is-active','is-done'));
  }
  toggle(){
    if (this.done) { this.reset(); }
    if (!this.started){ this.started = true; this.current = 0; this.remaining = this.steps[0].sec; this.enter(0); }
    this.playing = !this.playing;
    this.playBtn.textContent = this.playing ? 'Pause' : 'Resume';
    if (this.playing){ this.last = performance.now(); this.raf = requestAnimationFrame(this.loop); }
    else if (this.raf) cancelAnimationFrame(this.raf);
  }
  enter(i){
    this.current = i; this.remaining = this.steps[i].sec;
    this.items.forEach((el,idx)=>{ el.classList.toggle('is-active', idx===i); el.classList.toggle('is-done', idx<i); });
    this.icoEl.innerHTML = this.steps[i].ico;
    this.nameEl.textContent = this.steps[i].name;
    this.statusEl.textContent = this.steps[i].howto;
    this.tick();
  }
  tick(){
    const cur = this.steps[this.current];
    this.timeEl.textContent = this.fmt(this.remaining);
    this.prog.style.strokeDashoffset = (1 - Math.max(0, this.remaining / cur.sec)).toFixed(4);
  }
  loop(ts){
    if (!this.playing) return;
    const dt = (ts - this.last)/1000; this.last = ts;
    this.remaining -= dt;
    if (this.remaining <= 0){
      this.items[this.current].classList.add('is-done');
      if (this.current + 1 >= this.steps.length){ this.finish(); return; }
      this.enter(this.current + 1);
    } else { this.tick(); }
    this.raf = requestAnimationFrame(this.loop);
  }
  skip(){
    if (!this.started){ this.toggle(); return; }
    this.items[this.current].classList.add('is-done');
    if (this.current + 1 >= this.steps.length){ this.finish(); return; }
    this.enter(this.current + 1);
  }
  jump(i){
    if (!this.started){ this.started = true; }
    this.enter(i);
    if (!this.playing){ this.playing = true; this.playBtn.textContent = 'Pause'; this.last = performance.now(); this.raf = requestAnimationFrame(this.loop); }
  }
  finish(){
    this.playing = false; this.done = true; if (this.raf) cancelAnimationFrame(this.raf);
    this.items.forEach(el => { el.classList.remove('is-active'); el.classList.add('is-done'); });
    this.prog.style.strokeDashoffset = 0;
    this.icoEl.innerHTML = '';
    this.timeEl.textContent = 'Done';
    this.nameEl.textContent = 'Ritual complete';
    this.statusEl.textContent = 'Beautiful. Your mouth is fresh, clean and cared for.';
    this.playBtn.textContent = 'Restart';
  }
  reset(){
    this.playing = false; this.done = false; this.started = false; if (this.raf) cancelAnimationFrame(this.raf);
    this.current = 0; this.remaining = this.steps[0] ? this.steps[0].sec : 0;
    this.renderIdle();
  }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-study-article"] && !Shopify.designMode) return;
  try {
    
  // Wrap content tables so wide ones scroll sideways instead of overflowing the page.
  document.querySelectorAll('.gn-study__body table').forEach((table) => {
    if (table.parentElement.classList.contains('gn-study__table')) return;
    const wrap = document.createElement('div');
    wrap.className = 'gn-study__table';
    wrap.tabIndex = 0;
    table.before(wrap);
    wrap.append(table);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-us-trust-v2"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gn-us-trust-v2'))customElements.define('gn-us-trust-v2',class extends HTMLElement{connectedCallback(){if(this.played)return;const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');if(reduced.matches||!('IntersectionObserver' in window))return;this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.played=true;this.observer.disconnect();const nodes=[...this.querySelectorAll('[data-counter]')];if(!nodes.length)return;const start=performance.now();const tick=now=>{const p=Math.min(1,(now-start)/1500);nodes.forEach(el=>{const end=Number(el.dataset.counter);const digits=Number(el.dataset.decimals)||0;el.textContent=(end*(1-Math.pow(1-p,3))).toLocaleString('en-IN',{minimumFractionDigits:digits,maximumFractionDigits:digits});});if(p<1)this.frame=requestAnimationFrame(tick);else nodes.forEach(el=>el.textContent=Number(el.dataset.counter).toLocaleString('en-IN',{minimumFractionDigits:Number(el.dataset.decimals)||0,maximumFractionDigits:Number(el.dataset.decimals)||0}));};this.frame=requestAnimationFrame(tick);}},{threshold:.25});this.observer.observe(this);}disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.frame);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-us-trust-v3"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gn-us-trust-v3'))customElements.define('gn-us-trust-v3',class extends HTMLElement{connectedCallback(){if(this.played)return;const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');if(reduced.matches||!('IntersectionObserver' in window))return;this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.played=true;this.observer.disconnect();const nodes=[...this.querySelectorAll('[data-counter]')];if(!nodes.length)return;const start=performance.now();const tick=now=>{const p=Math.min(1,(now-start)/1500);nodes.forEach(el=>{const end=Number(el.dataset.counter);const digits=Number(el.dataset.decimals)||0;el.textContent=(end*(1-Math.pow(1-p,3))).toLocaleString('en-IN',{minimumFractionDigits:digits,maximumFractionDigits:digits});});if(p<1)this.frame=requestAnimationFrame(tick);else nodes.forEach(el=>el.textContent=Number(el.dataset.counter).toLocaleString('en-IN',{minimumFractionDigits:Number(el.dataset.decimals)||0,maximumFractionDigits:Number(el.dataset.decimals)||0}));};this.frame=requestAnimationFrame(tick);}},{threshold:.25});this.observer.observe(this);}disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.frame);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn-us-trust"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gn-us-trust'))customElements.define('gn-us-trust',class extends HTMLElement{connectedCallback(){if(this.played)return;const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');if(reduced.matches||!('IntersectionObserver' in window))return;this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.played=true;this.observer.disconnect();const nodes=[...this.querySelectorAll('[data-counter]')];if(!nodes.length)return;const start=performance.now();const tick=now=>{const p=Math.min(1,(now-start)/1500);nodes.forEach(el=>{const end=Number(el.dataset.counter);const digits=Number(el.dataset.decimals)||0;el.textContent=(end*(1-Math.pow(1-p,3))).toLocaleString('en-IN',{minimumFractionDigits:digits,maximumFractionDigits:digits});});if(p<1)this.frame=requestAnimationFrame(tick);else nodes.forEach(el=>el.textContent=Number(el.dataset.counter).toLocaleString('en-IN',{minimumFractionDigits:Number(el.dataset.decimals)||0,maximumFractionDigits:Number(el.dataset.decimals)||0}));};this.frame=requestAnimationFrame(tick);}},{threshold:.25});this.observer.observe(this);}disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.frame);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
